import { render } from "./ActionLinks.vue?vue&type=template&id=c2e3980e"
import script from "./ActionLinks.vue?vue&type=script&lang=js"
export * from "./ActionLinks.vue?vue&type=script&lang=js"

import "./ActionLinks.vue?vue&type=style&index=0&id=c2e3980e&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.19.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__